<template>
  <div>
    <transactions
      :transaction-class="transactionClass"
      :verbose-name="JSON.parse($route.params.sales) ? 'Bon de commande' : 'Ordre d\'achat'"
      :verbose-name-plural="JSON.parse($route.params.sales) ? 'Bons de commande' : 'Ordres d\'achats'"
      ressource="purchase-orders"
      :colors="colors"
    ></transactions>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import Transactions from '@/router/view/commercial/components/transactions'

const { PurchaseOrder } = Hk.Crm
export default {
  name: 'purchase-orders',

  components: {
    Transactions,
  },

  data() {
    return {
      transactionClass: null,
      colors: {
        active: 'warning',
        canceled: 'danger',
        ended: 'success',
      },
    }
  },

  mounted() {
    this.transactionClass = PurchaseOrder
  },
}
</script>

<style scoped></style>
